import { IconButton } from '@/layouts/authenticated/components/top-navigation/components/icon-button';
import { useOSDetection } from '@/hooks/use-os-detection';
import { useCommandDialog } from './index';

export function CommandDialogButton() {
  const commandDialog = useCommandDialog();
  const os = useOSDetection();

  const tooltip = `Search (${os === 'macOS' ? 'Cmd' : 'Ctrl'} + K)`;

  return (
    <IconButton
      icon="search"
      label="Search"
      tooltip={commandDialog.isOpen ? undefined : tooltip}
      onClick={commandDialog.toggle}
      isDisabled={commandDialog.isOpen}
    />
  );
}
